import { TaskTypeEnum } from '@sr-sdks/api-sdk-axios';
import { useQueries } from '@tanstack/react-query';
import { queryOptionsGetTasksPaginated } from '../api/task/taskApi';
import { TASK_TABS } from '../pages/v3/Tasks/taskTabs';

const EXCLUDING_TABS = TASK_TABS.filter(
  (tab) => tab.countExcludedStatuses?.length,
);

/**
 * Per-type count of listed tasks the badges leave out, subtracted from the total
 * so status-less tasks still count. Undefined until all land, so badges don't drop.
 */
export const useExcludedTaskCounts = (workspaceId?: string) =>
  useQueries({
    combine: (results) =>
      results.some((result) => result.isLoading)
        ? undefined
        : new Map<TaskTypeEnum, number>(
            EXCLUDING_TABS.map((tab, index) => [
              tab.type,
              results[index]?.data?.meta?.totalItems ?? 0,
            ]),
          ),
    queries: EXCLUDING_TABS.map((tab) => ({
      ...queryOptionsGetTasksPaginated({
        pageSize: 1,
        statuses: tab.countExcludedStatuses,
        type: tab.type,
        workspaceId,
      }),
      enabled: Boolean(workspaceId),
    })),
  });
